import { SupportedLinkPreview, SupportedLinkPreviewResourceType } from './types';

const SPOTIFY_HOSTS = new Set(['open.spotify.com']);

const stripFragment = (value: URL): string => {
  const normalizedUrl = new URL(value.toString());
  normalizedUrl.hash = '';
  return normalizedUrl.toString();
};

const toResourceType = (value: string): SupportedLinkPreviewResourceType | null => {
  switch (value.toLowerCase()) {
    case 'album':
      return 'album';
    case 'artist':
      return 'artist';
    case 'episode':
      return 'episode';
    case 'playlist':
      return 'playlist';
    case 'show':
      return 'show';
    case 'track':
      return 'track';
    default:
      return null;
  }
};

const toResourceLabel = (value: SupportedLinkPreviewResourceType): string => {
  switch (value) {
    case 'album':
      return 'Album';
    case 'artist':
      return 'Artist';
    case 'episode':
      return 'Episode';
    case 'playlist':
      return 'Playlist';
    case 'show':
      return 'Show';
    case 'track':
      return 'Track';
    default:
      return 'Spotify';
  }
};

export const buildSpotifyPreview = (url: string): SupportedLinkPreview | null => {
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.replace(/^www\./i, '').toLowerCase();

    if (!SPOTIFY_HOSTS.has(hostname)) {
      return null;
    }

    const pathSegments = parsedUrl.pathname.split('/').filter(Boolean);
    const resourceIndex = pathSegments[0]?.toLowerCase().startsWith('intl-') ? 1 : 0;
    const resourceSegment = pathSegments[resourceIndex] || '';
    const resourceId = pathSegments[resourceIndex + 1] || '';
    const resourceType = toResourceType(resourceSegment);

    if (!resourceType || !resourceId) {
      return null;
    }

    const resourceLabel = toResourceLabel(resourceType);
    const canonicalUrl = new URL(`https://open.spotify.com/${resourceSegment}/${resourceId}`);

    return {
      ariaLabel: `Open Spotify ${resourceLabel.toLowerCase()} in Spotify`,
      artworkUrl: '',
      canonicalUrl: stripFragment(canonicalUrl),
      eyebrow: 'Spotify',
      meta: resourceLabel,
      provider: 'spotify',
      resourceType,
      subtitle: 'Open in Spotify',
      title: `Spotify ${resourceLabel}`,
    };
  } catch (error) {
    return null;
  }
};
